import { render, staticRenderFns } from "./CollectionBanner.vue?vue&type=template&id=755609e2&scoped=true&lang=pug&"
import script from "./CollectionBanner.vue?vue&type=script&lang=js&"
export * from "./CollectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBanner.vue?vue&type=style&index=0&id=755609e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755609e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755609e2')) {
      api.createRecord('755609e2', component.options)
    } else {
      api.reload('755609e2', component.options)
    }
    module.hot.accept("./CollectionBanner.vue?vue&type=template&id=755609e2&scoped=true&lang=pug&", function () {
      api.rerender('755609e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionBanner.vue"
export default component.exports